import {ACTION_URL, REPORT_TYPES, LEAD_REPORT_COLUMNS, SALES_REPORT_COLUMNS, INVOICE_REPORT_COLUMNS} from "../Config/Variables";
import { jwtFetch } from "../utils/apiClient";
import {toPrice} from "../Config/Helper";
import {useState} from "react";
import {Dropdown, Spinner, Modal} from "react-bootstrap";
import Select from "react-select";
import {format, subMonths} from "date-fns";
import * as XLSX from 'xlsx';
import {saveAs} from 'file-saver';

const MarketingReports = (props) => {
  document.title = 'Report - CuanCuan';
  const userData = props.userData;
  const [reportType, setReportType] = useState({value: 'Leads', label: 'Leads'});
  const [reportStart, setReportStart] = useState(format(subMonths(new Date(), 1), 'yyyy-MM-dd'));
  const [reportEnd, setReportEnd] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [columns, setColumns] = useState(null);
  const [data, setData] = useState(null);
  const [summary, setSummary] = useState(null);
  const [prompt, setPrompt] = useState('');
  const [conversation, setConversation] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isGenerated, setIsGenerated] = useState(false);
  const [showSummary, setShowSummary] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);
  
  const leadGetReport = async () => {
    try {
      setIsLoading(true);
      const leadGetReportRequest = {
        start_date: reportStart,
        end_date: reportEnd
      }
      const leadGetReportFetch = await jwtFetch(ACTION_URL + 'lead-get-report', {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(leadGetReportRequest)
      });
      const leadGetReportResponse = await leadGetReportFetch.json();
      if (leadGetReportResponse.status === 200) {
        setColumns(LEAD_REPORT_COLUMNS);
        setData(leadGetReportResponse.data);
      } else {
        console.log(leadGetReportResponse.message);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error in leadGetReport:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoading(false);
    }
  };
  
  const salesGetReport = async () => {
    try {
      setIsLoading(true);
      const salesGetReportRequest = {
        start_date: reportStart,
        end_date: reportEnd
      }
      const salesGetReportFetch = await jwtFetch(ACTION_URL + 'quotation-get-report', {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(salesGetReportRequest)
      });
      const salesGetReportResponse = await salesGetReportFetch.json();
      if (salesGetReportResponse.status === 200) {
        setColumns(SALES_REPORT_COLUMNS);
        setData(salesGetReportResponse.data);
      } else {
        console.log(salesGetReportResponse.message);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error in salesGetReport:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoading(false);
    }
  };
  
  const invoiceGetReport = async () => {
    try {
      setIsLoading(true);
      const invoiceGetReportRequest = {
        start_date: reportStart,
        end_date: reportEnd
      }
      const invoiceGetReportFetch = await jwtFetch(ACTION_URL + 'invoice-get-report', {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(invoiceGetReportRequest)
      });
      const invoiceGetReportResponse = await invoiceGetReportFetch.json();
      if (invoiceGetReportResponse.status === 200) {
        setColumns(INVOICE_REPORT_COLUMNS);
        setData(invoiceGetReportResponse.data);
      } else {
        console.log(invoiceGetReportResponse.message);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error in invoiceGetReport:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoading(false);
    }
  };

  const generateReport = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    switch (reportType.value) {
      case 'Leads': leadGetReport(); break;
      case 'Sales': salesGetReport(); break;
      case 'Invoice': invoiceGetReport(); break;
      default: break;
    }
    setIsGenerated(true);
    setIsLoading(false);
    window.history.pushState({generated: true}, '', `${window.location.pathname}?generated=true`);
  }

  const aiSummarize = async () => {
    try {
      setShowSummary(true);
      setIsLoading(true);
      if (!columns || !Array.isArray(columns) || !data || !Array.isArray(data)) {
        return;
      }

      const header = columns.map(col => col.header ?? col.label ?? col.value);
      const rows = data.map(item => (
        columns.map(col => {
          const value = item[col.value];
          if (col.type === 'number') {
            const num = Number(value);
            return Number.isFinite(num) ? num : '';
          }
          if (col.type === 'date') {
            return value ? format(new Date(value), 'yyyy-MM-dd') : '';
          }
          if (col.type === 'datetime') {
            return value ? format(new Date(value), 'yyyy-MM-dd HH:mm:ss') : '';
          }
          return value ?? '';
        })
      ));

      const toonData = await import('@toon-format/toon').then((module) => {
        return module.encode([header, ...rows]);
      });

      const aiSummarizeRequest = {
        user: userData.user_keyid,
        data: toonData,
        type: reportType.value
      }
      const aiSummarizeFetch = await jwtFetch(ACTION_URL + 'report-summarize', {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(aiSummarizeRequest)
      });
      const aiSummarizeResponse = await aiSummarizeFetch.json();
      if (aiSummarizeResponse.status === 200) {
        setSummary(aiSummarizeResponse.data);
      } else {
        console.log(aiSummarizeResponse.message);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error in aiSummarize:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoading(false);
    }
  }

  const aiPrompt = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true);

        setConversation(prev => [...prev, {role: 'user', content: prompt}]);
      setPrompt('');

      if (!columns || !Array.isArray(columns) || !data || !Array.isArray(data)) {
        return;
      }

      const header = columns.map(col => col.header ?? col.label ?? col.value);
      const rows = data.map(item => (
        columns.map(col => {
          const value = item[col.value];
          if (col.type === 'number') {
            const num = Number(value);
            return Number.isFinite(num) ? num : '';
          }
          if (col.type === 'date') {
            return value ? format(new Date(value), 'yyyy-MM-dd') : '';
          }
          if (col.type === 'datetime') {
            return value ? format(new Date(value), 'yyyy-MM-dd HH:mm:ss') : '';
          }
          return value ?? '';
        })
      ));

      const toonData = await import('@toon-format/toon').then((module) => {
        return module.encode([header, ...rows]);
      });

      const aiPromptRequest = {
        user: userData.user_keyid,
        data: toonData,
        type: reportType.value,
        prompt: prompt
      }
      const aiPromptFetch = await jwtFetch(ACTION_URL + 'report-prompt', {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(aiPromptRequest)
      });
      const aiPromptResponse = await aiPromptFetch.json();
      if (aiPromptResponse.status === 200) {
        setConversation(prev => [...prev, {role: 'ai', content: aiPromptResponse.data}]);
      } else {
        setConversation(prev => [...prev, {role: 'ai', content: aiPromptResponse.message}]);
        console.log(aiPromptResponse.message);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error in aiPrompt:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoading(false);
    }
  }

  const exportXls = async () => {
    setIsLoading(true);
    if (!columns || !Array.isArray(columns) || !data || !Array.isArray(data)) {
      return;
    }

    const header = columns.map(col => col.header ?? col.label ?? col.value);
    const rows = data.map(item => (
      columns.map(col => {
        const value = item[col.value];
        if (col.type === 'number') {
          const num = Number(value);
          return Number.isFinite(num) ? num : '';
        }
        if (col.type === 'date') {
          return value ? format(new Date(value), 'yyyy-MM-dd') : '';
        }
        if (col.type === 'datetime') {
          return value ? format(new Date(value), 'yyyy-MM-dd HH:mm:ss') : '';
        }
        return value ?? '';
      })
    ));

    const aoa = [header, ...rows];
    const worksheet = XLSX.utils.aoa_to_sheet(aoa);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, reportType.value);
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});
    saveAs(blob, reportType.value + " Report - " + format(new Date(), 'dd MMM yyyy') + ".xlsx");
    setIsLoading(false);
  }

  const exportSheet = async () => {
    setIsLoading(true);
    if (!columns || !Array.isArray(columns) || !data || !Array.isArray(data)) {
      return;
    }

    const header = columns.map(col => col.header ?? col.label ?? col.value);
    const rows = data.map(item => (
      columns.map(col => {
        const value = item[col.value];
        if (col.type === 'number') {
          const num = Number(value);
          return Number.isFinite(num) ? num : '';
        }
        if (col.type === 'date') {
          return value ? format(new Date(value), 'yyyy-MM-dd') : '';
        }
        if (col.type === 'datetime') {
          return value ? format(new Date(value), 'yyyy-MM-dd HH:mm:ss') : '';
        }
        return value ?? '';
      })
    ));

    const dataSheet = [header, ...rows];
    try {
      const exportSheetRequest = {
        user: userData.user_keyid,
        email: userData.email_address,
        data: dataSheet,
        type: reportType.value,
      }
      const exportSheetFetch = await jwtFetch(ACTION_URL + 'report-export-sheet', {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(exportSheetRequest),
      });
      const exportSheetResponse = await exportSheetFetch.json();
      window.open(exportSheetResponse.data.url, '_blank');
    } catch (error) {
      console.error('Error uploading report:', error);
    }
    setIsLoading(false);
  }

  return (
    <div id="marketing-report">
      <section>
        <div className="d-flex align-items-center mb-3">
          <a href="/dashboard">Dashboard</a>
          <span className="mx-3"><i className="bi bi-chevron-right"/></span>
          <a href="/reports">Generate Report</a>
          {isGenerated && (
            <>
              <span className="mx-3"><i className="bi bi-chevron-right"/></span>
              <span>{`${reportType.value} Report`}</span>
            </>
          )}
        </div>
      </section>
      
      {isGenerated ? (
        <section>
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="card border-1">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-18">{reportType.value} Report</div>
                    <div className="d-flex gap-2">
                      <div className="btn-group" role="group">
                        <button className="btn btn-outline-secondary" type="button" onClick={() => aiSummarize()}><i className="bi bi-stars me-2"></i>Summarize</button>
                        <button className="btn btn-outline-secondary" type="button" onClick={() => setShowPrompt(true)}><i className="bi bi-chat-dots me-2"></i>Ask AI</button>
                      </div>
                      <Dropdown disabled={isLoading}>
                        <Dropdown.Toggle variant="outline-secondary"><i className="bi bi-download me-2"/>Export</Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item href="#google-sheet" onClick={() => exportSheet()}>Google Sheet</Dropdown.Item>
                          <Dropdown.Item href="#excel-xlsx" onClick={() => exportXls()}>Excel XLSX</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                  {data ? (
                    <div>
                      <div className="summary-box mb-3">
                        <p className="mb-1">
                          <span className="d-inline-block w-90">Total records</span>
                          <span className="d-inline-block w-20">:</span>
                          {data.length || 0}
                        </p>
                        <p className="mb-1">
                          <span className="d-inline-block w-90">Created date</span>
                          <span className="d-inline-block w-20">:</span>
                          {format(new Date(reportStart), 'd MMM yyyy')} - {format(new Date(reportEnd), 'd MMM yyyy')}
                        </p>
                        {reportType.value === 'Leads' && (
                          <div>
                            <p className="mb-1">
                              <span className="d-inline-block w-90">Budget Sum</span>
                              <span className="d-inline-block w-20">:</span>
                              <span className="d-inline-block">
                                {toPrice(
                                  data
                                    .reduce((sum, item) => sum + Number(item.bant_budget), 0), 
                                  'IDR'
                                )}
                              </span>
                            </p>
                          </div>
                        )}
                        {reportType.value === 'Sales' && (
                          <div>
                            <p className="mb-1">
                              <span className="d-inline-block w-90">Gross Sales</span>
                              <span className="d-inline-block w-20">:</span>
                              <span className="d-inline-block">
                                {toPrice(
                                  data
                                    .filter(item => item.quotation_status === 'Won')
                                    .reduce((sum, item) => sum + Number(item.helper_qt_grand_total), 0),
                                  'IDR'
                                )}
                              </span>
                            </p>
                            <p className="mb-1">
                              <span className="d-inline-block w-90">Gross Profit</span>
                              <span className="d-inline-block w-20">:</span>
                              <span className="d-inline-block">
                                {toPrice(
                                  data
                                    .filter(item => item.quotation_status === 'Won')
                                    .reduce((sum, item) => sum + Number(item.helper_qt_margin), 0),
                                  'IDR'
                                )}
                              </span>
                            </p>
                            <p className="mb-1">
                              <span className="d-inline-block w-90">Biggest Deal</span>
                              <span className="d-inline-block w-20">:</span>
                              <span className="d-inline-block">
                                {toPrice(
                                  data
                                    .filter(item => item.quotation_status === 'Won')
                                    .reduce((max, item) => Math.max(max, Number(item.helper_qt_margin)), 0),
                                  'IDR'
                                )}
                              </span>
                            </p>
                            <p className="mb-1">
                              <span className="d-inline-block w-90">Smallest Deal</span>
                              <span className="d-inline-block w-20">:</span>
                              <span className="d-inline-block">
                                {toPrice(
                                  data
                                    .filter(item => item.quotation_status === 'Won')
                                    .reduce((min, item) => Math.min(min, Number(item.helper_qt_margin)), 0),
                                  'IDR'
                                )}
                              </span>
                            </p>
                            <p className="mb-1">
                              <span className="d-inline-block w-90">Win Rate</span>
                              <span className="d-inline-block w-20">:</span>
                              <span className="d-inline-block">
                                {(() => {
                                  const allCodes = new Set(data.map(i => i.quotation_code));
                                  const wonCodes = new Set(
                                    data
                                      .filter(i => i.quotation_status === 'Won')
                                      .map(i => i.quotation_code)
                                  );
                                  const total = allCodes.size || 1;
                                  const won = wonCodes.size;
                                  const pct = (won / total) * 100;
                                  return `${pct.toFixed(2)}%`;
                                })()}
                              </span>
                            </p>
                          </div>
                        )}
                      </div>
                      <div className="table-responsive">
                        <table className="table table-gold freeze-col-2">
                          <thead>
                            <tr>
                              <th style={{ width: 30 }}>#</th>
                              {columns.map((row, r) => (
                                <th className={row.align === 'end' ? 'text-end' : undefined} style={{ width: Number(row.width) }} key={`header-${r}`}>{row.header}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {data
                              ?.sort((a, b) => new Date(b.created_on) - new Date(a.created_on))
                              .map((item, i) => (
                              <tr key={`row-${i}`}>
                                <td>{i + 1}</td>
                                {columns.map((row, r) => (
                                  <td className={row.align === 'end' ? `text-end` : ''} key={`value-${r}`}>
                                    {row.type === 'string' && item[row.value]}
                                    {row.type === 'number' && Number(item[row.value])}
                                    {row.type === 'date' && (item[row.value] ? format(new Date(item[row.value]), 'd MMM yyyy') : '')}
                                    {row.type === 'datetime' && (item[row.value] ? format(new Date(item[row.value]), 'd MMM yyyy HH:mm:ss') : '')}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : <Spinner/>}
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <section>
          <div className="row mt-4">
            <div className="col-md-6">
              <div className="card border-1">
                <div className="card-body">
                  <div className="fs-18 mb-3">Generate Report</div>
                  <form className="form-gold" onSubmit={(e) => generateReport(e)}>
                    <div className="row form-group">
                      <div className="col-md-4">
                        <label>Report Type</label>
                      </div>
                      <div className="col-md-8">
                        <Select options={REPORT_TYPES} value={reportType} onChange={(value) => setReportType(value)}/>
                      </div>
                    </div>
                    <div className="row form-group align-items-center mb-2">
                      <div className="col-md-4">
                        <label>Created Date</label>
                      </div>
                      <div className="col-md-4">
                        <input className="form-control" type="date" value={reportStart} onChange={(e) => setReportStart(e.target.value)} required/>
                      </div>
                      <div className="col-md-4">
                        <input className="form-control" type="date" value={reportEnd} onChange={(e) => setReportEnd(e.target.value)} required/>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end">
                      {isLoading ? <Spinner/> : (
                        <button className="btn bg-gold ms-2" type="submit">Generate</button>
                      )}                    
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <Modal show={showSummary} onHide={() => setShowSummary(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? <Spinner/> : (
            <div className="table-responsive">
              <div dangerouslySetInnerHTML={{ __html: summary?.replace(/```html/g, '').replace(/```/g, '') }} />
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showPrompt} onHide={() => setShowPrompt(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Ask AI</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column justify-content-end">
            {conversation.map((message, m) => (
              <div className="" key={`message-${m}`}>
                <div className={`table-responsive p-3 border-radius-3 mb-3 ${message.role === 'user' ? 'ms-4 bg-gold' : 'me-4 bg-white border-gold'}`} dangerouslySetInnerHTML={{ __html: message.content.replace(/```html/g, '').replace(/```/g, '') }}></div>
              </div>
            ))}
          </div>
          {isLoading ? <Spinner/> : (
            <form className="w-100" onSubmit={(e) => aiPrompt(e)}>
              <div className="input-group">
                <textarea className="form-control" value={prompt} placeholder="Type your question here" onChange={(e) => setPrompt(e.target.value)} required/>
                <span className="input-group-text d-flex align-items-center justify-content-center p-0">
                  <button className="btn btn-link btn-circle align-self-center w-100 h-100" type="submit"><i className="bi bi-send"/></button>
                </span>
              </div>
            </form>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MarketingReports;
